import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(private titleService: Title, private meta: Meta) {}

  setTitle(title: string) {
    this.titleService.setTitle(
      `${title} | Kreador Business Suite`
    );
  }

  resetTitle() {
    this.titleService.setTitle('Kreador Business Suite | Kreador, your business in all in one platform');
  }

  getTitle(): string {
    return this.titleService.getTitle();
  }

  getTitleWithoutApp(): string {
    const title = this.titleService.getTitle();
    const appSuffix = ' | Kreador Business Suite';
    if (title.endsWith(appSuffix)) {
      return title.slice(0, -appSuffix.length).trim();
    }
    return ''
  }

  setMetaDatas(metaDatas: { name: string; content: string }[]) {
    metaDatas.forEach((metaData) => {
      this.meta.updateTag({ name: metaData.name, content: metaData.content });
    });
  }

  resetMetaDatas(metaDatas: { name: string }[]) {
    metaDatas.forEach((metaData) => {
      this.meta.removeTag(`name='${metaData.name}'`);
    });
  }
}
